<template>
  <div class="mobile-navigation-sub-products-fi">
    <ul
      class="mobile-navigation-sub-products-fi__list mobile-navigation-sub-products-fi__list--services"
    >
      <li
        class="mobile-navigation-sub-products-fi__item mobile-navigation-sub-products-fi__item--group"
      >
        <a
          :href="groupData?.url"
          :target="groupData?.target"
          class="mobile-navigation-sub-products-fi__item__wrapper"
        >
          <span class="mobile-navigation-sub-products-fi__item__label">
            {{ navigationLayerTitle(groupData) }}
          </span>

          <arrow-icon class="mobile-navigation-sub-products-fi__item__icon" />
        </a>
      </li>
      <li
        v-for="item in subElements"
        :id="`fi-navigation-${item.CategoryId}`"
        :key="item.CateogryId"
        class="mobile-navigation-sub-products-fi__item mobile-navigation-sub-products-fi__item--page"
      >
        <a
          :href="item.url"
          :target="item.target ? item.target : null"
          class="mobile-navigation-sub-products-fi__item__wrapper"
        >
          <span class="mobile-navigation-sub-products-fi__item__label">
            {{ item.label }}
          </span>

          <arrow-icon class="mobile-navigation-sub-products-fi__item__icon" />
        </a>
      </li>
    </ul>
    <ul class="mobile-navigation-sub-products-fi__list">
      <li
        v-for="(item, index) in getAllCategories"
        :id="`fi-navigation-${item.CategoryId}`"
        ref="productItem"
        :key="item.CateogryId"
        :class="{
          'mobile-navigation-sub-products-fi__item': true,
          'mobile-navigation-sub-products-fi__item--last-category':
            index === getAllCategories.length - 1,
        }"
      >
        <a
          :href="groupData?.url + item.Slug"
          :target="item.Target ? item.Target : null"
          class="mobile-navigation-sub-products-fi__item__wrapper"
        >
          <div class="mobile-navigation-sub-products-fi__item__image-wrapper">
            <cloud-image-fi
              :src="item.thumbnailUrl ? item.thumbnailUrl.Url : placeholder"
              :alt="item.thumbnailUrl ? item.thumbnailUrl.Alt : item.CategoryName"
              width="75"
              height="62"
              params="func=fit"
              class="mobile-navigation-sub-products-fi__item__image"
            />
          </div>
          <span class="mobile-navigation-sub-products-fi__item__label">
            {{ item.CategoryName }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useQuery } from '@urql/vue';
import { ArrowIcon, CloudImageFi } from 'atoms';
import { computed, onServerPrefetch } from 'vue';

import { useFischer } from '@/composables/fischerPlugin';
import { useNavigation } from '@/composables/navigation';
import { useSalesChannelFilter } from '@/composables/salesChannelFilter';
import GETALLCATEGORIES from '@/graphql/getAllCategories.gql';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({ name: 'MobileNavigationSubProductsFi' });

const navigationStore = useNavigationStore();
const fischer = useFischer();
const { getSalesChannels, isPublicAssortment } = useSalesChannelFilter();
const { navigationLayerTitle } = useNavigation();

const groupData = computed(() => navigationStore.groupData);
const subElements = computed(() => navigationStore.subElements);
const placeholder = '';

const { data, executeQuery } = useQuery({
  query: GETALLCATEGORIES,
  variables: computed(() => ({
    baseSiteId: fischer.baseSiteId(),
    language: fischer.catalogLocale(),
    salesChannels: getSalesChannels(),
    publicAssortment: isPublicAssortment(),
  })),
});
onServerPrefetch(async () => {
  await executeQuery();
});

const getAllCategories = computed(() => data.value?.getAllCategories ?? []);
</script>

<style scoped src="./mobile-navigation-sub-products-fi" />
